/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Example_Step_3Inputs */

const da_forside_example_step_3 = /** @type {(inputs: Forside_Example_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Læg rettevejledning og omsætningstabel ind under Materiale.`)
};

/** @type {(inputs: Forside_Example_Step_3Inputs) => LocalizedString} */
const en_forside_example_step_3 = da_forside_example_step_3;

/**

* @param {Forside_Example_Step_3Inputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_example_step_3 = /** @type {((inputs?: Forside_Example_Step_3Inputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Example_Step_3Inputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_example_step_3(inputs)
	return /** @type {LocalizedString} */ ("Læg rettevejledning og omsætningstabel ind under Materiale.")
});